import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import logo from "./image.png";

const Login = () => {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();
        console.log("%c--- CONNEXION @M SERVICES ---", "color: #008080; font-weight: bold");
        setLoading(true);
        setError("");

        try {
            const response = await fetch("https://kanban.amservices.eu/api/login.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ username, password }),
            });

            const rawText = await response.text();
            console.log("Réponse brute du serveur :", rawText);

            try {
                const data = JSON.parse(rawText);

                if (data.success) {
                    // On stocke UNIQUEMENT ce que ton API renvoie
                    localStorage.setItem("userId", data.user.id);
                    localStorage.setItem("userName", data.user.username);
                    
                    console.log("Succès ! ID utilisateur stocké :", data.user.id);

                    // Redirection vers le Kanban
                    navigate("/suivi-production"); 
                } else {
                    setError(data.message || "Identifiants incorrects");
                }
            } catch (jsonErr) {
                console.error("Erreur de parsing JSON", jsonErr);
                setError("Format de réponse invalide");
            }
        } catch (err) {
            console.error("Erreur réseau/CORS", err);
            setError("Le serveur ne répond pas");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-page">
            <div className="login-card">
                <img src={logo} alt="@m Services" className="login-logo" />
                <form onSubmit={handleLogin}>
                    <h2>Espace Collaborateur</h2>

                    {error && <div className="error-badge">{error}</div>}

                    <div className="input-group">
                        <input
                            type="text"
                            placeholder="Utilisateur"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                        />
                    </div>

                    <div className="input-group">
                        <input
                            type="password"
                            placeholder="Mot de passe"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>

                    <button type="submit" className="btn-login" disabled={loading}>
                        {loading ? "Vérification..." : "Se connecter"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Login;